export default __webpack_public_path__ + "static/media/7.d608b681.svg";